// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_order/create_purchase_order.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseOrderItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseOrderRequest
 */
export class CreatePurchaseOrderRequest extends Message<CreatePurchaseOrderRequest> {
  /**
   * ID of the supplier for the purchase order
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * List of items to be included in the purchase order
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseOrderItem items = 2;
   */
  items: PurchaseOrderItem[] = [];

  /**
   * Optional notes for the purchase order
   *
   * @generated from field: string notes = 3;
   */
  notes = "";

  /**
   * List of purchase request IDs to include in the purchase order
   *
   * @generated from field: repeated string purchase_request_ids = 4;
   */
  purchaseRequestIds: string[] = [];

  /**
   * ID of the stock point where the items will be received
   *
   * @generated from field: string stock_point_id = 5;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<CreatePurchaseOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: PurchaseOrderItem, repeated: true },
    { no: 3, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "purchase_request_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseOrderRequest {
    return new CreatePurchaseOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseOrderRequest {
    return new CreatePurchaseOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseOrderRequest {
    return new CreatePurchaseOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseOrderRequest | PlainMessage<CreatePurchaseOrderRequest> | undefined, b: CreatePurchaseOrderRequest | PlainMessage<CreatePurchaseOrderRequest> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseOrderRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseOrderResponse
 */
export class CreatePurchaseOrderResponse extends Message<CreatePurchaseOrderResponse> {
  /**
   * ID of the created purchase order
   *
   * @generated from field: string purchase_order_id = 1;
   */
  purchaseOrderId = "";

  /**
   * Unique purchase order number
   *
   * @generated from field: string purchase_order_number = 2;
   */
  purchaseOrderNumber = "";

  constructor(data?: PartialMessage<CreatePurchaseOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseOrderResponse {
    return new CreatePurchaseOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseOrderResponse {
    return new CreatePurchaseOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseOrderResponse {
    return new CreatePurchaseOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseOrderResponse | PlainMessage<CreatePurchaseOrderResponse> | undefined, b: CreatePurchaseOrderResponse | PlainMessage<CreatePurchaseOrderResponse> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseOrderResponse, a, b);
  }
}

